
import * as React from 'react';
import { WithItemCache, IItemCacheStateProps } from '../withItemCache/WithItemCache';
import { WithAction, IActionStateProps } from '../withAction/WithAction';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { ItemDefaultClickAction } from '../actions/defaultClick/DefaultClickAction';
import { displayNameFacet } from '../../facets/ItemFacets';

export interface IItemLinkProps {
  itemKey: string;
}

export const ItemLink: React.ComponentType<IItemLinkProps> = (props: IItemLinkProps & React.Props<{}>): JSX.Element => {
  return (
    <WithItemCache>
      { ({ itemCache }: IItemCacheStateProps) => {
        let children: React.ReactNode;

        if (!props.children) {
          const displayName = itemCache.demandItemFacet(displayNameFacet, props.itemKey);

          children = displayName;
        } else {
          children = props.children;
        }

        return (
          <WithAction
            action={ <ItemDefaultClickAction itemKey={ props.itemKey } /> }
          >
            { ({ isAvailable, execute }: IActionStateProps) => {
              const onClick = isAvailable ? () => {
                execute();
              } : undefined;

              return (
                <Link onClick={ onClick }>{ children }</Link>
              );
            } }
          </WithAction>
        );
      } }
    </WithItemCache>
  );
};
